export default {
  computed: {

  },
  methods: {
    getActividadesPorContrato(idContrato) {
      const actividadesContrato = this.getContratoActividadesTodas
        .filter((a) => (
          a.idContrato === idContrato
            && a.tipo === 2
            && new Date(`${a.fecha} 00:00:0`) >= new Date(`${this.fechaDelInforme} 00:00:0`)
            && new Date(`${a.fecha} 00:00:0`) <= new Date(`${this.fechaAlInforme} 00:00:0`)
        )).map((a) => ({
          descripcion: a.descripcion,
          fecha: a.fecha,
          idFrente: a.frente.id,
          descripcionFrente: a.frente.descripcion,
          ordenFrente: a.frente.orden,
        }))
        .sort((a, b) => a.ordenFrente - b.ordenFrente);

      const frentes = actividadesContrato
        .map(({ descripcionFrente }) => descripcionFrente);
      const actividadesFrentes = frentes.filter((item, index) => frentes.indexOf(item) === index)
        .map((f) => ({
          frente: f,
          detalles: actividadesContrato.filter((a) => a.descripcionFrente === f)
            .sort((a, b) => new Date(`${a.fecha} 00:00:0`) - new Date(`${b.fecha} 00:00:0`))
            .map((d, index) => ({ ...d, numero: index + 1 })),
        }));
      return actividadesFrentes;
    },
    async generarPdfActividades() {
      const nombreTemplate = 'templateInformeActividades';
      const datosContrato = this.formatoObjeto(this.getContrato);

      const datosFecha = this.formatoObjeto({
        fechaDel: this.fechaDelInforme,
        fechaAl: this.fechaAlInforme,
      });
      const fechaTitulo = `del ${datosFecha.fechaDel_texto.slice(0, datosFecha.fechaDel_texto.length - 7)}
        al ${datosFecha.fechaAl_texto}`;
      const logo = this.getCliente?.logo || '';

      const contratosRelacionados = this.getContrato.contratosRelacionados
        .map((c) => c.contratoRelacionado)
        .sort((a, b) => a.orden - b.orden);

      /* let actividadesRelacionados = this.getContrato.contratosRelacionados
        .map(({ contratoRelacionado }) => ({
          contratista: contratoRelacionado,
          actividades: this.getActividadesPorContrato(contratoRelacionado.id),
        })); */

      let actividadesRelacionados = contratosRelacionados
        .map(({ id }) => ({
          contratista: contratosRelacionados
            .find((contratoRelacionado) => contratoRelacionado.id === id),
          actividades: this.getActividadesPorContrato(id),
        }));

      const actividadesContrato = {
        contratista: { numero: this.getContrato.numero },
        actividades: this.getActividadesPorContrato(this.getContrato.id),
      };

      const tipoContrato = this.getContrato?.obras[0].obra.tipo.descripcion || '';

      if (tipoContrato === 'OBRA') {
        actividadesRelacionados = [];
      }

      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: false,
            format: 'A3',
            footerTemplate: '',
          },
          nombreTemplate,
        },
        data: {
          contrato: datosContrato,
          tipoContrato,
          actividades: [...actividadesRelacionados],
          actividadesContrato,
          fecha: datosFecha,
          fechaTitulo,
          logo,
          numeroInforme: this.numeroInforme,
          footer: '',
        },
      }, `${this.contrato.numero}_Actividades_${this.fechaDelInforme}_${this.fechaAlInforme}`);
      this.documentoSeleccionado = null;
    },
  },
};
